// Local imports
import { get_shopify_params } from './parse.js';

// Module name
export const MODULE_NAME = 'url';

export let global_vars = {};

// In a browser, global === window
export function initialize(global) {
    let url = global.location.href;
    let localstorage = global.localStorage;
    get_shopify_params(global, localstorage, url);
}
